module.exports = __webpack_public_path__ + "static/clean-code-3cda8dce4d3fa622575e7ca676cde80b.jpg";